<template>
  <multi-select
    :options="selectableUsersList"
    :values="selectedUsers"
    @change="onChange($event)"
    :placeholder="placeholder"
    :error="error"
  >
    <template v-slot:default="item">
      <div class="d-flex user-pill">
        <user-short class="pl-2" :user-id="item.value.id" length="18"></user-short>
        <span class="user-text text-truncate" :title="item.value.displayName" v-no-capture>{{
          item.value.displayName
        }}</span>
      </div>
    </template>
    <template v-slot:listItem="option">
      <div class="d-flex dropdown-item-container">
        <user-short class="pl-2" :user-id="option.option.id" length="18"></user-short>
        <span class="pl-2 user-text" v-no-capture>{{ option.option.displayName }}</span>
      </div>
    </template>
  </multi-select>
</template>

<script>
import * as R from 'ramda'
import UserShort from '@/components/UserShort'
import MultiSelect from '@/components/form/MultiSelect'
import MembershipsMixin from '@/mixins/MembershipsMixin'

/**
 * This is a MultiSelect field that enables selection users
 */
export default {
  name: 'UsersMultiSelect',
  props: {
    teamId: {
      type: [Number, String]
    },
    orgId: {
      type: [Number, String]
    },
    placeholder: {
      default: 'Select Users'
    },
    selected: {
      default: () => []
    },
    error: String
  },
  mixins: [MembershipsMixin],
  data() {
    return {}
  },
  computed: {
    users() {
      const users = this.$store.getters.teamMemberships(this.teamId)
      return users
        .map(u => ({ ...u.user, label: u.user.displayName }))
        .sort((a, b) => {
          return a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
        })
    },
    selectedUsers() {
      return this.selected
        .map(userId => this.$store.getters.userById(userId))
        .filter(user => !!user)
    },
    selectableUsersList() {
      return R.differenceWith((x, y) => x.id === y.id, this.users, this.selectedUsers)
    },
    type() {
      return this.teamId ? 'team' : 'organization'
    }
  },
  components: {
    UserShort,
    MultiSelect
  },
  mounted() {
    this.updateMemberships(this.orgId, this.teamId)
  },
  methods: {
    onChange(users) {
      const userIds = users.map(R.prop('id'))
      this.$emit('change', userIds)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-pill {
  /deep/ .user-short-container {
    padding: 0 5px !important;
  }
}
/deep/ .user-short-container {
  padding-top: 0 !important;
}
.dropdown-item-container {
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 0.875rem;
}

.user-text {
  top: 2px;
  font-size: 0.875rem;
  line-height: 18px;
}

/deep/ .dropdown-item {
  padding-top: 0;
  padding-bottom: 0;
}

/deep/ .dropdown-menu {
  max-height: 250px;
  overflow-y: auto;
}
</style>
